import {
  FORM_ADD_PAYTO_ACCOUNT_NUMBER_NAME,
  FORM_ADD_PAYTO_BANK_NAME_NAME,
  FORM_ADD_PAYTO_BSB_NAME,
} from 'features/to/const';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import { isFunction } from 'lodash';
import React from 'react';

const withAddPaytoBankVerified = (Component) => {
  const AddPaytoBankVerifiedComponent = (props) => {
    const { setAddManual } = props || {};

    const { paytoAccountInformation, setPaytoAccountInformation } =
      usePaytoStore();

    const handleBankAccountVerifiedOnSelect = (item, payloadExt = {}) => {
      const { senderBankId, bankCode, bankName, bsb, accountNumber } =
        item || {};
      const payload = {
        ...paytoAccountInformation,
        [FORM_ADD_PAYTO_BSB_NAME]: bsb,
        [FORM_ADD_PAYTO_BANK_NAME_NAME]: bankName,
        [FORM_ADD_PAYTO_ACCOUNT_NUMBER_NAME]: accountNumber,
        id: senderBankId,
        bankCode,
        ...payloadExt,
      };
      setPaytoAccountInformation(payload);

      if (isFunction(setAddManual)) {
        setAddManual(false);
      }
    };

    const newProps = {
      ...props,
    };
    return (
      <Component {...newProps} onSelect={handleBankAccountVerifiedOnSelect} />
    );
  };
  return AddPaytoBankVerifiedComponent;
};

export default withAddPaytoBankVerified;
